import { useCallback, useEffect, useState } from 'react'

interface Options {
  width?: number
  extremum?: 'min' | 'max'
}

const getMediaQueryMatch = ({ width = 767, extremum = 'max' }: Options): boolean | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }

  return window.matchMedia(`(${extremum}-width: ${width}px)`).matches
}

export const useMediaQuery = ({ width = 767, extremum = 'max' }: Options): undefined | boolean => {
  const [isMatch, setIsMatch] = useState<undefined | boolean>(
    getMediaQueryMatch({ width, extremum })
  )
  const onChange = useCallback(
    () => setIsMatch(getMediaQueryMatch({ width, extremum })),
    [width, extremum]
  )

  useEffect(() => {
    onChange()
    window.addEventListener('resize', onChange)

    return () => window.removeEventListener('resize', onChange)
  }, [onChange])

  return isMatch
}
